import React from 'react';
import { Link } from 'react-router-dom';

const LOGO_SRC = '/images/Logos/logo-alturion-linear.png';

/**
 * Logo Alturion Lab. (mark + wordmark empilés, fond transparent).
 * className contrôle surtout la hauteur (ex. h-9, h-12).
 */
const BrandLogo = ({ to = '/', className = 'h-9', imgClassName = '', link = true }) => {
  const image = (
    <img
      src={LOGO_SRC}
      alt="Alturion Lab."
      className={`w-auto object-contain object-left ${className} ${imgClassName}`}
    />
  );

  if (!link) return image;

  return (
    <Link to={to} className="inline-flex items-center" aria-label="Alturion Lab.">
      {image}
    </Link>
  );
};

export default BrandLogo;
